// Polyfills
import "lazysizes";
import "cookieconsent";

// Custom
import './nav'
import './navbar'
import './customers'
import './cases-slider'
import './explore'

// Vendor
import "./vendor/mediabox.min";
import 'leaflet/dist/leaflet';

window.cookieconsent.initialise({
    "palette": {
        "popup": {
            "background": "#002429",
            "text": "#FFFFFF"
        },
        "button": {
            "background": "#2E5CF4",
            "text": "#FFFFFF"
        }
    },
    "showLink": false
});

// Application files
